import React, { useEffect } from 'react'

interface Props {
    title: string;
    alwaysVisibleChildren?: React.ReactNode;
    children: React.ReactNode;
    sizeDependencies?: any[];
    open?: boolean;
    alwaysOpen?: boolean;
}

export default function DealModalSection(props: Props) {
    const [open, setOpen] = React.useState(props.open || false);
    const [maxHeight, setMaxHeight] = React.useState(0);
    const divRef = React.useRef<HTMLDivElement>(null);

    const toggleOpen = () => {
        const newMaxHeight = open ? 0 : divRef.current?.scrollHeight || 0;
        setMaxHeight(newMaxHeight);
        setOpen(!open);
    }

    useEffect(() => {
        setMaxHeight(open ? divRef.current?.scrollHeight || 0 : 0)
    }, [props.sizeDependencies, open])

    useEffect(() => {
        if (props.open) {
            setTimeout(() => setMaxHeight(divRef.current?.scrollHeight || 0), 100)
        }
        // eslint-disable-next-line
    }, [props.open])


    return (
        <div className='px-4'>
            <div onClick={toggleOpen} className='d-flex pointer justify-content-between align-items-center'>
                <h6>{props.title}</h6>
                {!props.alwaysOpen && <i className={`bi ${maxHeight ? 'bi-chevron-up' : 'bi-chevron-down'}`} />}
            </div>

            {props.alwaysVisibleChildren}
            {props.alwaysOpen
                ? <div>{props.children}</div>
                : <div ref={divRef} className='animate' style={{
                    maxHeight,
                    overflow: open ? 'unset' : 'hidden',
                    opacity: open ? 1 : 0,
                }}>
                    {props.children}
                </div>}
        </div>
    )
}
